<div>
  <p-toast position="top-center"></p-toast> 
  <p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay"
  >
    <div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
      <p-progressSpinner
      ></p-progressSpinner>
    </div>
  </p-dialog>
  <p-dialog
    appendTo="body"
    width="500px"
    [(visible)]="showP2PChart"
  >
    <app-p2p-chart appendTo="body" [fcounts]="fcounts" [pcounts]="pcounts" #p2pChartComponent></app-p2p-chart>
  </p-dialog>
<p-dialog
  appendTo="body"
  [style]="{width: '75vw', height: '80vh'}"
  [resizable]="true"
  [(visible)]="showPainCharts"
>
  <app-pain-score-charts appendTo="body" #painScoreCharts></app-pain-score-charts>
</p-dialog>

  <!-- Filter Controls Outside TreeTable -->
  <div class="table-filter-toolbar">
    <div class="table-filter-controls">
      <!-- Start of Search Bar For Big Screen -->
      <div *ngIf="screenWidth > 767">
        <div class="search-bar">
          <i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" (keydown.enter)="submitGlobalFilter()" style="margin: 4px 2px 0 0"></i>
          <input type="text" placeholder="Table Search" pInputText 
            [(ngModel)]="filter.globalSearch"
            (keyup.enter)="submitGlobalFilter()"
            class="searchStyle"/>
        </div>
      </div>
      <!-- End of Search Bar For Big Screen -->

      <!-- Start of Search Bar For Small Screen -->
      <div *ngIf="screenWidth <= 767" class="table-mobile-search">
        <span pTooltip="Search" tooltipPosition="bottom">
          <p-button (click)="showSearchDialog()" icon="pi pi-search" styleClass="p-button-secondary"></p-button>
        </span>
      </div>
      <!-- End of Search Bar For Small Screen -->
      <div id="serviceGrpApp">
        <app-service-grp-select [defaultService]="filter.serviceGroup" (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
      </div>
      <div id="locationApp">
        <app-location-select 
          [user]="authService.user" 
          [footprint]="footprint"
          [deId]="deId" 
          [filter]="locationSelectFilter" 
          [showReset]="false"
          (locationSelected)="onLocationChanged($event)"
          (initComplete)="onLocationChanged($event)"
          (clearTableSearch)="clearTableSearch()"
          (clearFilterPills)="handleClearFilterPills()">
        </app-location-select>
      </div>
    </div>
    <div class="table-filter-actions">
      <app-refresh-button [disabled]="!dataLoaded" (refresh)="refreshToInitialState()"></app-refresh-button>
      <div>
        <span pTooltip="{{getViewTooltip()}}" tooltipPosition="bottom">
          <p-button icon="pi pi-sliders-h" styleClass="p-button-secondary" (click)="changeToWeightView()"></p-button>
        </span>
      </div>
      <div>
        <span pTooltip="Advance Filter" tooltipPosition="bottom">
          <p-button icon="pi pi-filter" styleClass="p-button-secondary" [disabled]="!dataLoaded" (click)="openFilterModal()"></p-button>
        </span>
      </div>
    </div>
  </div>
  
  <p-treeTable
    #analyticstt
    [value]="records"
    [paginator]="true"
    [rows]="20"
    [totalRecords]="totalCount"
    [lazy]="true"
    (onLazyLoad)="loadRecordsLazy($event)" 
    [paginator]="true"
    [rows]="20"
    (onNodeExpand)="onNodeExpand($event)"
    >

    <ng-template pTemplate="header">
      <tr>
        <th [ttSortableColumn]="'adminId'" style="border-top-left-radius: 10px;">
          <span>
            User ID
            <p-treeTableSortIcon [field]="'adminId'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'adminName'">
          <span>
            User Name
            <p-treeTableSortIcon [field]="'adminName'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'normMedDescription'">
          <span>
            Med Group
            <p-treeTableSortIcon [field]="'normMedDescription'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'locationGrouping'">
          <span>
            Area
            <p-treeTableSortIcon [field]="'locationGrouping'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'normAdminType'">
          <span>
            Role
            <p-treeTableSortIcon [field]="'normAdminType'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'shiftworked'" style="font-weight: bold;">
          <span>
            Shift
            <p-treeTableSortIcon [field]="'shiftWorked'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'numberOfStandardDeviationsMean'">
          <span>
            Peer Score
            <p-treeTableSortIcon [field]="'numberOfStandardDeviationsMean'"></p-treeTableSortIcon>
          </span>
        </th>
        <th *ngIf="!weightView" [ttSortableColumn]="'totalCountofPtscaredforbyAdmin'">
          <span>
            Patient Count
            <p-treeTableSortIcon [field]="'totalCountofPtscaredforbyAdmin'"></p-treeTableSortIcon>
          </span>
        </th>
        <th *ngIf="!weightView" [ttSortableColumn]="'adminFlagCount'">
          <span pTooltip="Med Quantites - 2 Decimals &#013; Transaction Counts - No Decimals" tooltipPosition="bottom" style="width: 400px">
            Audit Quantity Basis
            <p-treeTableSortIcon [field]="'adminFlagCount'"></p-treeTableSortIcon>
          </span>
        </th>
        <th [ttSortableColumn]="'transactionType'">
          <span>
            Audit Type
            <p-treeTableSortIcon [field]="'transactionType'"></p-treeTableSortIcon>
          </span>
        </th>
        <th *ngIf="weightView">
          Audit Total
        </th>
        <th *ngIf="weightView">
          Total Patients
        </th>
        <th *ngIf="weightView">
          Total Per Patient
        </th>
        <th *ngIf="weightView">
          Patients Per Shift
        </th>
        <th *ngIf="!weightView" style="text-align: center; width: 213px; border-top-right-radius: 10px;">
            Pain Score Data
        </th>
        <th *ngIf="!headerEnabled">
          print
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <ng-container [ngSwitch]="getNodeLevel(rowNode)">
        
        <tr *ngSwitchCase="1" class="maap-row-level1">
            <td colspan="1">
              <p-treeTableToggler [rowNode]="rowNode">
                <ng-template>
                </ng-template>
              </p-treeTableToggler>
              <span tabindex="0" style="cursor:pointer; font-size:14px;"
                (click)="$event.currentTarget.previousSibling.children[0].click()" (keydown.enter)="$event.currentTarget.previousSibling.children[0].click()">{{ isDeId(rowData.adminId) }}</span>
              <!-- {{log(rowNode)}} -->
            </td>  
            <td>
              <span>{{ isDeId(formatName(rowData.adminName)) }}</span>
            </td>
            <td pTooltip="{{rowData.medGroupName}}">{{rowData.medGroupName | slice:0:15}}{{rowData.medGroupName.length > 15 ? '..': ''}}</td>
            <td>{{ isDeId(rowData.locationGrouping) }}</td>
            <td>
              {{ rowData.normAdminType }}
            </td>
            <!-- <td class="text-center" *ngIf="headerEnabled">{{ rowData.userRemovalsPts }}</td>
            <td class="text-center" *ngIf="headerEnabled">{{ rowData.allUsersRemovalsPtsMean }}</td>
            -->
            <td class="text-center"> {{rowData.shiftworked}}</td>
            <td tabindex="0" class="text-center"><img tabindex="0" class="maap-flag-icon" [title]="getFlagTitle(rowData.numberOfStandardDeviationsMean)" (click)="openP2PChart(rowData)" (keydown.enter)="openP2PChart(rowData)"
                style="cursor:default" [src]="getFlagColor(rowData.numberOfStandardDeviationsMean)" alt="" ></td>
            <!-- <td *ngIf="headerEnabled" class="text-center">{{ rowData.numberOfStandardDeviationsMean| number : '1.2-2' }}<img tabindex="0" (click)="openP2PChart(rowData)" class="ico_trending" src="/assets/images/icon_trending.png"></td> -->
            <td *ngIf="!weightView" class="text-center"> {{rowData.totalCountofPtscaredforbyAdmin}}</td>
            <td *ngIf="!weightView" class="text-center"> {{rowData.adminFlagCount | formatQuantity}} </td>
            <td *ngIf="rowData.transactionType !== 'Waste'">{{ rowData.transactionType }}</td>
            <td tabindex="0" *ngIf="rowData.transactionType === 'Waste'" class="waste-link" style="cursor: pointer; font-size: 14px; font-weight: bold;" (click)="showRadarWaste(rowData)">
                {{ rowData.transactionType }}
            </td>
            <td *ngIf="weightView">
              <span [pTooltip]="getAuditTotalTooltip(rowData)" tooltipPosition="bottom">
                <p-progressBar [ngClass]="{'redBar': rowData.adjustmentFactor > 1.5, 
                  'yellowBar' : (rowData.adjustmentFactor >= 0.5 && 1.5 >= rowData.adjustmentFactor),
                  'greenBar' : rowData.adjustmentFactor > -100 && 1 > rowData.adjustmentFactor}"
                unit="" 
                [showValue]="false" 
                [value]="getWeightValue(rowData.adjustmentFactor,3)">
                </p-progressBar>
              </span>
            </td>
            <td *ngIf="weightView">
              <span [pTooltip]="getPatientTotalTooltip(rowData)" tooltipPosition="bottom">
                <p-progressBar [ngClass]="{'redBar': rowData.PatientNumStandardDevsFromMean > 3.0, 
                                          'yellowBar' : (rowData.PatientNumStandardDevsFromMean >= 1.0 && 3.0 > rowData.PatientNumStandardDevsFromMean),
                                          'greenBar' : rowData.PatientNumStandardDevsFromMean > -100 && 1.0 > rowData.PatientNumStandardDevsFromMean}"
                unit="" 
                [showValue]="false" 
                [value]="getWeightValue(rowData.PatientNumStandardDevsFromMean, 5)">
                </p-progressBar>
              </span>
            <td *ngIf="weightView">
              <span [pTooltip]="getPerPatientTotalTooltip(rowData)" tooltipPosition="bottom">
                <p-progressBar [ngClass]="{'redBar': rowData.correctedFlagsPerPatientStd > 2.0, 
                                          'yellowBar' : (rowData.correctedFlagsPerPatientStd >= 1 && 2.0 >= rowData.correctedFlagsPerPatientStd),
                                          'greenBar' : rowData.correctedFlagsPerPatientStd > -100 && 1 > rowData.correctedFlagsPerPatientStd}"
                unit="" 
                [showValue]="false" 
                [value]="getWeightValue(rowData.correctedFlagsPerPatientStd, 3)">
                </p-progressBar>
              </span>
            </td>
            <td *ngIf="weightView">
              <span [pTooltip]="getPtPerShiftTotalTooltip(rowData)" tooltipPosition="bottom">
                <p-progressBar [ngClass]="{'redBar': rowData.patientsPerShiftStd > 2.0, 
                                          'yellowBar' : (rowData.patientsPerShiftStd >= 1.0 && 2.0 >= rowData.patientsPerShiftStd),
                                          'greenBar' : rowData.patientsPerShiftStd > -100 && 1.0 > rowData.patientsPerShiftStd}"
                unit="" 
                [showValue]="false" 
                [value]="getWeightValue(rowData.patientsPerShiftStd, 3)">
                </p-progressBar>
              </span>
            </td>
            <td tabindex="0" *ngIf="!weightView" class="text-center" style="cursor: pointer; text-decoration: none;" (click)="openPainScores(rowData)">
              <i class="pi pi-chart-line pain-score-link-icon"></i>
            </td>
            <td class="text-center table-row-print" *ngIf="!headerEnabled">
              <a tabindex="0" (click)="openPrintUrl(rowData)" (keydown.enter)="openPrintUrl(rowData)"><img class="print-icon" src="/assets/images/print_icon.png" alt=""></a>
            </td>
        </tr>

        <tr *ngSwitchCase="2" class="maap-row-level2">
          <td colspan="11" [class]="rowClass(rowData.label) + ' p2p-group-row'"
              style="text-align: left; border-style: none; font-weight:bold;">
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <span tabindex="0" style="cursor:pointer"
              (click)="$event.currentTarget.previousSibling.children[0].click()" (keydown.enter)="$event.currentTarget.previousSibling.children[0].click()">{{rowData.label}}</span>
          </td>
        </tr>

        <tr *ngSwitchCase="3" [ngClass]="{'p2p_shift_node_header': rowData.shiftDate === 'Shift Date', 'p2p_shift_node' : rowData.index === 0,'p2p_shift_node_1' : rowData.index === 1}" 
            class="p2p-shift-row" style="text-align: left; border-style: none; font-weight:bold;">
          <ng-container *ngIf="rowData?rowData['shiftDate'] && rowData['transType'] !== 'Waste' && rowData['transType'] !== 'Chart':false; else maybeWaste">
            <td colspan="2">
              <p-treeTableToggler [rowNode]="rowNode" [ngClass]="[rowData.shiftDate === 'Shift Date' ? 'node_exapnd_hider' : 'node_expand_shower']"> </p-treeTableToggler>
                {{ rowData.shiftDate !== 'Shift Date' ? rowData.shiftDateDisplay : rowData.shiftDate }}
            </td>
            <td>{{rowData.shiftworked}}</td>
            <td>{{rowData.patientCount}}</td>
            <td>{{rowData.adminFlagCount}}</td>
            <td>{{rowData.transactionsVolume}}</td>
            <td>{{rowData.uom}}</td>
            <td colspan="4" class='p2p_shift_node_parent'></td>
            
          </ng-container>

            <ng-template #maybeWaste>
              <ng-container *ngIf="rowData?rowData['shiftDate'] && (rowData['transType'] === 'Waste' || rowData['transType'] === 'Chart'):false; else medUse">
                <td colspan="2">
                  <p-treeTableToggler [rowNode]="rowNode" [ngClass]="[rowData.shiftDate === 'Shift Date' ? 'node_exapnd_hider' : 'node_expand_shower']"> </p-treeTableToggler>
                  {{ rowData.shiftDate !== 'Shift Date' ? rowData.shiftDateDisplay : rowData.shiftDate }}
                </td>
                <td>{{rowData.shiftworked}}</td>
                <td>{{rowData.patientCount}}</td>
                <td>{{rowData.interactionCount}}</td>
                <td>{{rowData.adminFlagCount}}</td>
                <td>{{rowData.uom}}</td>
                <td colspan="4" class='p2p_shift_node_parent'></td>
                
              </ng-container>
            </ng-template>

            <ng-template #medUse>
              <ng-container *ngIf="rowData?rowData['shiftDate'] && rowData['transType'] === 'Med Use':false; else rowUndefined">
                <td colspan="2">
                  <p-treeTableToggler [rowNode]="rowNode" [ngClass]="[rowData.shiftDate === 'Shift Date' ? 'node_exapnd_hider' : 'node_expand_shower']"> </p-treeTableToggler>
                    {{ rowData.shiftDate !== 'Shift Date' ? rowData.shiftDateDisplay : rowData.shiftDate }}
                </td>
                <td>{{rowData.shiftworked}}</td>
                <td>{{rowData.patientCount}}</td>
                <td>{{rowData.adminFlagCount}}</td>
                <td>{{rowData.interactionCount}}</td>
                <td>{{rowData.transactionsVolume}}</td>
                <td>{{rowData.uom}}</td>
                <td colspan="5" class='p2p_shift_node_parent'></td>
                
              </ng-container>
            </ng-template>

            <ng-template #rowUndefined>

              <td colspan="11 text-center">
                <span class="font-weight-bold font-italic no-transaction-message">No Transaction Record!</span>
              </td>

            </ng-template>
        </tr>
        <tr *ngSwitchCase="4" [ngClass]="{'p2p_shift_node_child_1' : rowData.index === 0,'p2p_shift_node_child_2' : rowData.index === 1, 'p2p_shift_node_child_3' : rowData.index === 2}" 
            class="p2p-child-row" style="text-align: left; border-style: none; font-weight:bold !important;">
          <ng-container *ngIf="rowData?rowData['transType'] !== 'Waste' && rowData['transType'] !== 'Chart':false; else wasteNode">
            <td></td>
            <td colspan="2">{{ rowData.adminDateTimeDisplay || rowData.adminDateTime }}</td>
            <td>{{isDeId(rowData.patientId)}}</td>
            <td>{{rowData.adminFlagCount}}</td>
            <!-- <td>{{rowData.interactionCount}}</td> -->
            <td>{{rowData.transactionsVolume}}</td>
            <td>{{rowData.uom}}</td>
            <td colspan="4"></td>
          </ng-container>
          
          <ng-template #wasteNode>
            <ng-container *ngIf="rowData?rowData['transType'] === 'Waste' || rowData['transType'] === 'Chart':false; else rowUndefined">
              <td></td>
              <td colspan="2">{{ rowData.adminDateTimeDisplay || rowData.adminDateTime }}</td>
              <td>{{ isDeId(rowData.patientId) }}</td>
              <td>{{rowData.interactionCount}}</td>
              <td>{{rowData.adminFlagCount}}</td>
              <td>{{rowData.uom}}</td>
              <td colspan="4"></td>
            </ng-container>
          </ng-template>

          <ng-template #rowUndefined>

            <td colspan="11 text-center">
              <span class="font-weight-bold font-italic no-transaction-message">No Transaction Record!</span>
            </td>

          </ng-template>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="paginatorfirstpagelinkicon">
      <p-button type="button" icon="pi pi-angle-double-left" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatorpreviouspagelinkicon">
      <p-button type="button" icon="pi pi-angle-left" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatornextpagelinkicon">
      <p-button type="button" icon="pi pi-angle-right" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatorlastpagelinkicon">
      <p-button type="button" icon="pi pi-angle-double-right" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-treeTable>
  
  <p-dialog header="Filter Data" [style]="{width: '45rem'}" class="filterHeader" appendTo="body" [(visible)]="filterDialog">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
            <label for="userName">User Name</label>
            <p-select 
              [options]="filterOptions.userName"
              [(ngModel)]="filterDraft.userName"
              [filter]="true" 
              [virtualScroll]="true" 
              virtualScrollItemSize="30" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>
        </div>

        <div class="form-group">
            <label for="userID">User ID</label>
            <p-select 
              [options]="filterOptions.userID"
              [(ngModel)]="filterDraft.userID"
              [filter]="true" 
              [virtualScroll]="true" 
              virtualScrollItemSize="30" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>
        </div>

        <div class="form-group">
            <label for="medGroupName">Medication Group</label>
            <p-select 
              [options]="filterOptions.medGroupName"
              [(ngModel)]="filterDraft.medGroupName"
              [filter]="true" 
              [virtualScroll]="true" 
              virtualScrollItemSize="30" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: auto;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>           
        </div>
        <div class="form-group">
          <label for="p2p_type">Audit Type</label>
            <p-select 
              [options]="filterOptions.p2p_type" 
              [(ngModel)]="filterDraft.p2p_type"
              [filter]="true" 
              virtualScrollItemSize="9" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>
        </div>

      </div>
      <div class="col-md-6">
        <div class="form-group">
            <label for="adminGrouping">Role</label>
            <p-select 
              [options]="filterOptions.adminGrouping"
              [(ngModel)]="filterDraft.adminGrouping"
              [filter]="true" 
              [virtualScroll]="true" 
              virtualScrollItemSize="30" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>
        </div>

        <div class="form-group">
            <label for="p2p">Peer Score</label>
            <p-select 
              [options]="filterOptions.p2p" 
              [(ngModel)]="filterDraft.p2p"
              [filter]="true" 
              [virtualScroll]="true" 
              virtualScrollItemSize="4" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>
        </div>

        <div class="form-group">
            <label for="shiftworked">Shift</label>
            <p-select 
              [options]="filterOptions.shiftworked"
              [(ngModel)]="filterDraft.shiftworked"
              [filter]="true" 
              [virtualScroll]="true" 
              virtualScrollItemSize="30" 
              [showClear]="true" 
              [styleClass]="'maap-filter-dropdown w-100'">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em; position: relative; top: -8px">{{item.label}}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                  <div style="float:center;margin-top:4px">
                    {{item.label}}</div>
                </div>
              </ng-template>
            </p-select>
        </div>


        <p-footer>
          <div class="form-group peer-advanced-filter-actions mt-3">
            <p-button label="Clear" icon="pi pi-trash" styleClass="p-button-sm advanced-filter-action" (click)="clearFilter()"></p-button>
              <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-sm advanced-filter-action" (click)="closeFilterModal()"></p-button>
              <p-button label="Submit" icon="pi pi-check" styleClass="p-button-sm advanced-filter-action" (click)="submitAdvancedFilter();filterDialog=false"></p-button>
          </div>
        </p-footer>
      </div>
    </div>

    <p-footer class="float-right"> </p-footer>
  </p-dialog>

  <p-dialog header="Waste Witness Monitoring - {{witnessMed}}" [selectedRow]="selectedRow"
            [(visible)]="radarWasteChart" [style]="{width: '90vw', 'max-width': '1400px', height: '85vh'}" 
            class="witnessHeader witness-dialog" [contentStyle]="{'overflow': 'hidden', 'display': 'flex', 'flex-direction': 'column', 'height': '100%', 'padding': '15px'}">
    <div style="flex-shrink: 0;">
      <label class="witness-dialog-label" style="font-weight: bold;">Date Range: {{witnessStartDateDisplay}} - {{witnessEndDateDisplay}}</label>
    </div>
    <div *ngIf="loadingWitnessData" class="text-center" style="flex: 1; display: flex; align-items: center; justify-content: center;">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div *ngIf="!loadingWitnessData" class="row" style="display: flex; flex-wrap: nowrap; justify-content: center; align-items: stretch; margin: 15px 0 0 0; padding: 0; flex: 1; min-height: 0;">
      <div class="col-6" style="min-width: 350px; flex: 1 1 50%; display: flex; flex-direction: column; padding-right: 10px;">
        <div class="radar-chart-panel" style="width: 100%; height: 100%; border-radius: 12px; padding: 12px; display: flex; flex-direction: column; min-height: 0;">
          <p-chart #radarChart type="radar" [data]="wasteWitnessesData" [options]="radarWasteOptions" style="flex: 1; min-height: 0;"></p-chart>
        </div>
      </div>
      <div class="col-6" style="min-width: 320px; flex: 1 1 50%; display: flex; flex-direction: column; padding-left: 10px; min-height: 0;">
        <div style="padding: 0; width: 100%; flex-shrink: 0; margin-bottom: 10px;">
          <input type="checkbox" name="limitWitnesses" [(ngModel)]="limitWitnesses" (click)="limitWitnessResults()">
          <label class="witness-dialog-label" style="padding-left: 1vw;"> Limit results to common witnesses </label>
        </div>
        <div style="flex: 1; width: 100%; overflow: auto; min-height: 0; display: flex; flex-direction: column;">
          <p-table class="waste-witness-table" [columns]="witnessGroupCols" [value]="witnessGroupIDs" [scrollable]="true" scrollDirection="vertical" scrollHeight="flex" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr class="table-header">
                  <th class="share-col-header waste-witness-table-header" style="border-top-left-radius: 4px;">
                    <input type="checkbox" name="selectedAll" [(ngModel)]="selectAll" (click)="selectWholeGroup($event)" class="SelectAllCheck">
                  </th>   
                  <th class="waste-witness-table-header">
                    Peer Group Admins
                  </th>
                  <th class="waste-witness-table-header" style="border-top-right-radius: 4px;">
                    Waste Volume
                  </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                 <tr [ngClass]="{'waste-witness-initial': initialSelectedAdminId === rowData.id}">
                    <td>
                      <input class="share-col-header" (change)="witnessIdSelected($event, rowData)" type="checkbox" value="" [(ngModel)]="rowData.isSelected" id="flexCheckDefault">
                    </td>
                    <td *ngIf="deId">******, ******</td>
                    <td *ngIf="!deId">{{formatName(rowData?.name)}}</td>
                    <td style="padding-left: 5%;">{{rowData?.volume | formatQuantity}} {{rowData?.uom}}</td>
                 </tr>
            </ng-template>
          </p-table> 
        </div>
      </div>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="searchDialog" [showHeader]="false" [modal]="true" [closable]="true" [dismissableMask]="true"
  [style]="{ width: '28rem'}" styleClass="rounded-dialog" [baseZIndex]="10000" appendTo="body">
<div class="search-bar">
<i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" (keydown.enter)="submitGlobalFilter()" (click)="this.searchDialog=false" (keydown.enter)="this.searchDialog=false" style="margin: 4px 2px 0 0"></i>
<input type="text" placeholder="Table Search" pInputText [pAutoFocus]="true" [(ngModel)]="this.filter.globalSearch" class="searchStyle"
(keyup.enter)="submitGlobalFilter()" (keyup.enter)="this.searchDialog=false"/>
</div>
<ng-template pTemplate="footer">
<div class="dialog-footer-message">Hit enter to search</div>
</ng-template>
</p-dialog>


</div>
